import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaButtonDropdown from './VaButtonDropdown.vue'

export default withConfigTransport(VaButtonDropdown)
